function obfuscateEmail(email) {
  let splitEmail = email.split('@');
  let obfuscatedPart = splitEmail[0].substring(0,2) + '*'.repeat(splitEmail[0].length - 2);
  return obfuscatedPart + '@' + ( splitEmail[1] || '' );
}

export default obfuscateEmail;
